module.exports = __webpack_public_path__ + "static/img/ios2.0665a85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ios2.jpg
// module id = /uXm
// module chunks = 1